import { Html } from '@react-three/drei';
import { Box } from '@react-three/flex';
import { useRef, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard'
import css from './Style.css'

function Links() {
  const [isCopied, setIsCopied] = useState();
  const [isHovered, setIsHovered] = useState(false);

  const handleCopy = () => {
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 1000);
    console.log('copied')
  }

  return (
    <>
      <Box>
        <Html>                    
          <CopyToClipboard 
            text='pdxjosephb@gmail.com'
            onCopy={handleCopy}
          >
          <img
            className={css.mailIcon}
            src='./pictures/Mail-gray.png' 
            alt='copy email'
            value='pdxjosephb@gmail.com' 
            />
          </CopyToClipboard>
        </Html>
      </Box>
      <Box>
      <Html>
        <a href='https://github.com/Joseph-K-B' >
          <img src='./pictures/git-gray-2.png' alt='github' className={css.gitIcon}/>
        </a>
      </Html>
      </Box>
      <Box>
        <Html>
          <a href='https://www.linkedin.com/in/joseph-k-brown/'>
            <img src='./pictures/linked-gray-2.png' alt='linkedin' className={css.linkedIcon}/>
          </a>
        </Html>
      </Box>
    </>
  );
};

export default Links;